import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningHook() {
  return <section className="py-10 sm:py-12 px-4 sm:px-6 lg:px-8 bg-navy-950 relative border-y border-gold-500/10" data-id="element-128">
      <div className="max-w-4xl mx-auto text-center" data-id="element-129">
        <FadeIn data-id="element-130">
          <p className="text-2xl sm:text-3xl md:text-4xl font-serif text-white leading-relaxed mb-8" data-id="element-131">
            Permíteme decirte algo que tu mente va a querer resistir: Tu vida{' '}
            <span className="text-gold-400 italic" data-id="element-132">
              no es una secuencia de eventos aleatorios
            </span>{' '}
            que te pasan. No es el resultado de la mala suerte, ni de tus
            pecados, ni de la injusticia del mundo.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-133">
          <p className="text-lg sm:text-xl text-gray-400 leading-relaxed max-w-3xl mx-auto font-light" data-id="element-134">
            Es un juego de percepción. Un juego que tú mismo diseñaste, con las
            cartas que tú mismo elegiste y los hitos que tú mismo pactaste antes
            de entrar en este cuerpo físico. Estás aquí porque el Jugador que
            realmente eres decidió que hoy es el hito de tu despertar.
          </p>
        </FadeIn>
      </div>
    </section>;
}